import React from "react";
import moment from "moment/moment";
import UpdateStockModal from "./UpdateStockModal";

const Variant = ({
  stockVariantData,
  data,
  storeName,
  setInventoryValues,
  inventoryValues,
  storeId,
}) => {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title collapsed justify-content-between remove-icon bg-gray-300 rounded-bottom-0">
          <span>Variant</span>

          <span
            className="btn btn-primary font-weight-bold letter-spacing px-4 py-2"
            data-toggle="modal"
            data-target="#InventorymodalScrollable"
          >
            Update Stock
          </span>
        </div>
      </div>
      <div className="card-body overflow-hidden p-0">
        <div className="table-responsive Inventory-modals">
          <table
            className="table table-bordered text-center m-0"
            border="0"
            cellSpacing="0"
            cellPadding="0"
            width="100%"
          >
            <thead className="text-white bg-gray-700">
              <tr>
                <th nowrap="nowrap">Size/Model No.</th>
                <th nowrap="nowrap"> Product SKU</th>
                <th nowrap="nowrap"> Product MRP</th>
                <th nowrap="nowrap"> Batch Number</th>
                <th nowrap="nowrap"> HSN Code</th>
                <th nowrap="nowrap">Your Price</th>
                <th nowrap="nowrap">Stock Available</th>
                <th nowrap="nowrap">Min Order Quantity</th>
                <th nowrap="nowrap">Update Expiration Date</th>
                <th nowrap="nowrap">Selling Limit</th>
                <th nowrap="nowrap">Cash on Delivery</th>
                <th>PreBookable</th>

                <th>PreBooking Amount</th>
                <th nowrap="nowrap">PreBooking Start Date</th>
                <th nowrap="nowrap">PreBooking Last Date</th>
                <th nowrap="nowrap">Last Date For Full Payment</th>
                <th nowrap="nowrap">Auto Cancellable</th>
                <th>Cancellation Available</th>
                <th nowrap="nowrap">Cancellation Date</th>
                <th nowrap="nowrap">Estimated Stock Availability Date</th>
                <th nowrap="nowrap">Estimated Delivery End Date</th>
              </tr>
            </thead>
            <tbody className="font-weight-bolder">
              {stockVariantData?.map((variant, i) => {
                // moment(inventoryValues?.cancellationDate).format("YYYY-MM-DD");
                return (
                  <tr key={i.toString()}>
                    <td className="align-middle">{variant?.variantSize}</td>
                    <td
                      className="align-middle font-weight-bold"
                      style={{ width: "200px" }}
                    >
                      {variant?.sku}
                    </td>
                    <td
                      className="align-middle font-weight-bold"
                      style={{ width: "200px" }}
                    >
                      {variant?.mrp}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.batchNumber}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.hsnCode}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.price}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.stock}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.minimumOrderQuantity}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.lotExpirationDate
                        ? moment
                            .utc(variant?.lotExpirationDate)
                            .local()
                            .format("DD/MM/YYYY")
                        : ""}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.sellingLimit}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.cashOnDeliveryStatus ? "Yes" : "No"}
                    </td>{" "}
                    <td className="align-middle font-weight-bold">
                      {variant?.isPreBookAble ? "Yes" : "No"}
                    </td>{" "}
                    <td className="align-middle font-weight-bold">
                      {variant?.preBookAmount}
                    </td>{" "}
                    <td className="align-middle font-weight-bold">
                      {variant?.startDateForPreBook
                        ? moment
                            .utc(variant?.startDateForPreBook)
                            .local()
                            .format("DD/MM/YYYY")
                        : ""}
                    </td>{" "}
                    <td className="align-middle font-weight-bold">
                      {variant?.lastDateForPreBook
                        ? moment
                            .utc(variant?.lastDateForPreBook)
                            .local()
                            .format("DD/MM/YYYY")
                        : ""}
                    </td>{" "}
                    <td className="align-middle font-weight-bold">
                      {variant?.lastDateForFullPayment
                        ? moment
                            .utc(variant?.lastDateForFullPayment)
                            .local()
                            .format("DD/MM/YYYY")
                        : ""}
                    </td>{" "}
                    <td className="align-middle font-weight-bold">
                      {variant?.autoCancelAble ? "Yes" : "No"}
                    </td>{" "}
                    <td className="align-middle font-weight-bold">
                      {variant?.isCancellable ? "Yes" : "No"}
                    </td>{" "}
                    <td className="align-middle font-weight-bold">
                      {variant?.cancellationDate
                        ? moment
                            .utc(variant?.cancellationDate)
                            .local()
                            .format("DD/MM/YYYY")
                        : ""}
                    </td>{" "}
                    <td className="align-middle font-weight-bold">
                      {variant?.estimatedDeliveryDate
                        ? moment
                            .utc(variant?.estimatedDeliveryDate)
                            .local()
                            .format("DD/MM/YYYY")
                        : ""}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.estimatedDeliveryEndDate
                        ? moment
                            .utc(variant?.estimatedDeliveryEndDate)
                            .local()
                            .format("DD/MM/YYYY")
                        : ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <UpdateStockModal
        data={data}
        storeName={storeName}
        storeId={storeId}
        stockVariantData={stockVariantData}
        setInventoryValues={setInventoryValues}
        inventoryValues={inventoryValues}
      />
    </div>
  );
};

export default Variant;
